import { Component, inject, input } from '@angular/core';
import { CookieService, ProcessLinkService } from 'ngx-unificator/services';
import { TranslatePipe } from '../../../../../services/translation/translate.pipe';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';
import { COOKIE_ACCEPTED } from '../../../../../services/user/data/cookie-names.data';
import { ToastRef } from '../../toast-ref';
import { SafePipe } from 'ngx-unificator/pipes';
import { Router } from '@angular/router';
import { GlobalEventsService } from '../../../../../services/global-events.service';

@Component({
  selector: 'app-cookie-toast',
  templateUrl: './cookie-toast.component.html',
  styleUrls: ['./cookie-toast.component.scss'],
  imports: [TranslatePipe, SvgIconComponent, SafePipe],
})
export class CookieToastComponent {
  private _cookies = inject(CookieService);
  private _processLink = inject(ProcessLinkService);
  private _router = inject(Router);
  public events = inject(GlobalEventsService);
  public ref = input<ToastRef>()

  cookiesAccepted() {
    this._cookies.set(COOKIE_ACCEPTED, 'true', 999, '/');
    this.ref().close();
  }

  onProcessLink(event: MouseEvent) {
    event.preventDefault();
    const link = this._processLink.getHrefFromClickEvent(event);
    if (link) {
      this._router.navigateByUrl(link).then();
    }
  }
}
